import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n";
import { api } from "@/lib/api";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("sbpay_lang") || "ar");
  const [theme, setTheme] = useState(() => localStorage.getItem("sbpay_theme") || "dark");

  useEffect(() => {
    const t = translations[lang];
    document.documentElement.dir = t.dir;
    document.documentElement.lang = lang;
    document.documentElement.setAttribute("data-lang", lang);
    localStorage.setItem("sbpay_lang", lang);
  }, [lang]);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("sbpay_theme", theme);
  }, [theme]);

  const [features, setFeatures] = useState(null);
  useEffect(() => {
    api.get("/features").then((r) => setFeatures(r.data)).catch(() => setFeatures({ features: {}, payments_mode: "off" }));
  }, []);
  const can = (k) => !!features?.features?.[k];

  const t = translations[lang];
  const toggleLang = () => setLang((l) => (l === "ar" ? "en" : "ar"));
  const toggleTheme = () => setTheme((th) => (th === "dark" ? "light" : "dark"));

  return (
    <AppContext.Provider value={{ lang, setLang, toggleLang, t, theme, toggleTheme, features, can }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
